/**
 * 调试设备模拟器模块。
 */
import { useEffect } from "react";
import { RoomSection } from "@/components/remote/debugger/room-section";
import { SignalSection } from "@/components/remote/debugger/signal-section";
import { socket } from "@/services/remote/socket";
import { useConnectionStore } from "@/stores/remote";

/**
 * 远程设备端调试控制台。
 */
export default function Index() {
	const {
		currentRoomId,
		setCurrentRoomId,
		setSocket,
		startHeartbeat,
		stopHeartbeat,
	} = useConnectionStore();

	const myStatus = "READY";

	// 初始化 socket
	useEffect(() => {
		setSocket(socket);
	}, [setSocket]);

	// 当房间 ID 改变时，启动或停止心跳
	useEffect(() => {
		if (currentRoomId) {
			startHeartbeat();
		} else {
			stopHeartbeat();
		}
	}, [currentRoomId, startHeartbeat, stopHeartbeat]);

	useEffect(() => {
		socket.on(
			"room-message",
			({
				room,
				message,
				from,
			}: {
				room: string;
				message: string;
				from: string;
			}) => {
				console.log("device got message from room:", room, message, from);
			},
		);

		return () => {
			socket.off("room-message");
		};
	}, []);

	useEffect(() => {
		socket.on(
			"ready-to-link",
			async (
				data: { deviceId?: string },
				callback: (payload: {
					status: string;
					message?: string;
					roomId?: string;
					deviceId?: string;
				}) => void,
			) => {
				console.log("got ready to link event", data);

				if (myStatus !== "READY") {
					callback({
						status: "error",
						message: "Device is not ready",
					});
					return;
				}

				// 如果已经在房间中，直接返回当前房间ID
				if (currentRoomId) {
					callback({
						status: "ok",
						roomId: currentRoomId,
						deviceId: "AABBCC",
					});
					return;
				}

				// 创建一个随机的房间ID
				const roomId = Math.random().toString(36).substring(7);

				try {
					await socket.emit("join-room", roomId);
					setCurrentRoomId(roomId);
					callback({
						status: "ok",
						roomId,
						deviceId: "AABBCC", // 使用实际的设备ID
					});
				} catch (_error) {
					callback({
						status: "error",
						message: "Failed to create room",
					});
				}
			},
		);
		return () => {
			socket.off("ready-to-link");
		};
	}, [setCurrentRoomId, currentRoomId]);

	const registerDevice = async () => {
		const data = {
			deviceId: "AABBCC",
			accessCode: "123456",
		};

		socket
			.timeout(5000)
			.emit("create-device", data, (err: unknown, response: unknown) => {
				if (err) {
					console.log(" no response in time:", err);
				} else {
					console.log("got response", response);
				}
			});
	};

	return (
		<div className="py-2 mx-auto flex flex-col w-full md:w-1/2 xl:w-1/3 items-center gaps-2 justify-between">
			<div className="divider">Device</div>
			<div className="w-full">
				<div className="flex my-2 gap-4">
					<button
						type="button"
						className="btn btn-sm btn-default"
						onClick={async () => {
							await registerDevice();
						}}
					>
						Register Device ID
					</button>

					<button
						type="button"
						className="btn btn-sm btn-default"
						onClick={async () => {
							socket.emit("check-online-device");
						}}
					>
						Check Online Device
					</button>
				</div>
			</div>
			<div className="divider">Rooms</div>
			<RoomSection />
			<div className="divider">SIGNAL</div>
			<SignalSection />
		</div>
	);
}
